import React from 'react';
import { useSelector } from 'react-redux';

import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';

import {
  nearbyCitiesResourceDefinition,
  biggestCitiesResourceDefinition
} from './utils/queryDefinitions';
import BreederProfileLocationLinksGroup from './BreederProfileLocationLinksGroup';

interface BreederProfileNearbyCitiesProps {
  breedName: string;
  breedId: string | number;
  wideLayout?: boolean;
  limit?: number;
  breederProfileId?: string | null;
  isStatePage?: boolean;
}

export default function BreederProfileNearbyCities({
  breedName,
  breedId,
  wideLayout = false,
  limit = 20,
  breederProfileId = null,
  isStatePage = false
}: BreederProfileNearbyCitiesProps) {
  const { citySlug, locationTitle } = useSelector(({ server }: any) => server);

  const resourceDefinition = citySlug
    ? nearbyCitiesResourceDefinition(breedId, citySlug, breederProfileId)
    : biggestCitiesResourceDefinition(breedId, locationTitle);

  const { value: citiesData, isFetching } =
    useResourceQuery(resourceDefinition);

  return (
    <BreederProfileLocationLinksGroup
      breedName={breedName}
      linksData={citiesData}
      wideLayout={wideLayout}
      limit={limit}
      header={`Find ${breedName} puppies in nearby cities`}
      isStatePage={isStatePage}
      isFetching={isFetching}
    />
  );
}
